"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgDiamondPriceCircle(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#diamond-price-circle_svg__a)",
    fillRule: "evenodd",
    d: "M8 16A8 8 0 108 0a8 8 0 000 16z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M10.625 3.333h-5.25L2.167 6.25l5.833 7 5.833-7-3.208-2.917zM2.167 6.25h11.666"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M5.375 3.333L4.5 6.25 8 12.667l3.208-6.417-.583-2.917"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M4.5 6.25L8 3.625l3.208 2.625"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "diamond-price-circle_svg__a",
    x1: 16,
    x2: 16,
    y1: 16,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50E2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26BBD9"
  }))));
}

var MemoSvgDiamondPriceCircle = /*#__PURE__*/React.memo(SvgDiamondPriceCircle);
var _default = MemoSvgDiamondPriceCircle;
exports["default"] = _default;